import { Select } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';

import styled, { css } from 'styled-components';

import { colors } from '../../styles/colors/';

import ChevronDownIcon from '../Icons/ChevronDownIcon';
import { Spacer } from '../Spacer/Spacer';

const StyledSelect = styled(Select)`
  width: ${(props) => props.width || '100%'};
  border-radius: 3px;
  .ant-select-selection__rendered {
    width: 100%;
  }

  .ant-select-selection {
    align-items: center;
  }
`;

/**
 * Primary UI component for user interaction
 */

const { Option } = Select;

const AntdSelect = ({
  placeholder,
  optionData,
  disabled,
  error,
  handleChange,
  width,
  isMobile,
  ...props
}) => {
  const StyledBaseSelect = (
    <style>{css`
      .ant-select-dropdown-menu-item {
        color: ${colors['gray']['9']};
        font-size: ${isMobile ? '16px' : '14px'};
      }

      .ant-select:not(.ant-select-customize-input) .ant-select-selector {
        border: ${error ? `1px solid ${colors['red']['5']}` : `1px solid ${colors['gray']['3']}`};
      }

      .ant-select:not(.ant-select-disabled):hover .ant-select-selector {
        box-shadow: ${disabled
          ? 'none'
          : error
          ? `0px 0px 4px ${colors['red']['7']}`
          : `0px 0px 4px ${colors['indigo']['3']}`};
        border-color: ${disabled
          ? colors['gray']['3']
          : error
          ? colors['red']['5']
          : colors['indigo']['7']};
      }

      .ant-select-focused .ant-select-selection,
      .ant-select-selection:focus,
      .ant-select-selection:active {
        box-shadow: ${disabled
          ? 'none'
          : error
          ? `0px 0px 4px ${colors['red']['7']}`
          : `0px 0px 4px ${colors['indigo']['3']}`};
        border-color: ${disabled
          ? colors['gray']['3']
          : error
          ? colors['red']['5']
          : colors['indigo']['7']};
      }

      .ant-select-selection:hover {
        box-shadow: ${disabled
          ? 'none'
          : error
          ? `0px 0px 4px ${colors['red']['7']}`
          : `0px 0px 4px ${colors['indigo']['3']}`};
        border-color: ${disabled
          ? colors['gray']['3']
          : error
          ? colors['red']['5']
          : colors['indigo']['7']};
      }

      .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input)
        .ant-select-selector {
        box-shadow: ${disabled
          ? 'none'
          : error
          ? `0px 0px 4px ${colors['red']['7']}`
          : `0px 0px 4px ${colors['indigo']['3']}`};
        border-color: ${disabled
          ? colors['gray']['3']
          : error
          ? colors['red']['5']
          : colors['indigo']['7']};
      }

      .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
        height: ${isMobile ? '40px' : '32px'};
      }

      .ant-select-selection-item {
        display: flex;
        align-items: center;
      }
    `}</style>
  );

  const suffixIcon = (
    <Spacer>
      <ChevronDownIcon />
    </Spacer>
  );

  return (
    <React.Fragment>
      {StyledBaseSelect}
      <StyledSelect
        suffixIcon={suffixIcon}
        showSearch
        placeholder={placeholder}
        filterOption={(input, option) => {
          return String(option.props.children).toLowerCase().indexOf(input.toLowerCase()) >= 0;
        }}
        onChange={handleChange}
        disabled={disabled}
        error={error}
        width={width}
        isMobile={isMobile}
        {...props}
      >
        {optionData.map((option, index) => {
          return (
            <Option value={option.value} key={`${option.value}_${index}`}>
              {option.label}
            </Option>
          );
        })}
      </StyledSelect>
    </React.Fragment>
  );
};

AntdSelect.propTypes = {
  /**
   * Select contents
   */
  optionData: PropTypes.array,
  handleChange: PropTypes.func,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  width: PropTypes.string,
  isMobile: PropTypes.bool,
};

AntdSelect.defaultProps = {
  optionData: [],
  disabled: false,
  error: false,
  width: '100%',
  isMobile: false,
};

export { AntdSelect };
